import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const holidayApi = createApi({
  reducerPath: 'holidayApi',
  baseQuery: baseQueryV1,
  endpoints: (builder) => ({
    getHolidays: builder.query({
      query: (params) => ({
        url: 'holidays',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
    }),
    getHolidayStats: builder.query({
      query: (params) => ({
        url: 'holidays/stats',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
    }),

    getHolidaysByYear: builder.query({
      query: ({ year }) => ({
        url: `holidays/year/${year}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),

    addHoliday: builder.mutation({
      query: (payload) => ({
        url: 'holidays',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    updateHoliday: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `holidays/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    deleteHoliday: builder.mutation({
      query: (id) => ({
        url: `holidays/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useGetHolidaysQuery,
  useAddHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
  useGetHolidayStatsQuery,
  useGetHolidaysByYearQuery,
} = holidayApi;
